import {useIntl} from 'react-intl'
import {KTSVG} from '../../../helpers'
import {AsideMenuItemWithSub} from './AsideMenuItemWithSub'
import {AsideMenuItem} from './AsideMenuItem'

export function AsideMenuMain() {
  const intl = useIntl()

  return (
    <>
      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Person KYC</span>
        </div>
      </div>
      <AsideMenuItem
        to='/kyc/overview'
        icon='/assets/media/icons/duotune/communication/com013.svg'
        title='Overview'
        fontIcon='bi-layers'
      />
      <AsideMenuItem
        to='/kyc/data'
        icon='/assets/media/icons/duotune/general/gen017.svg'
        title='Data Records'
        fontIcon='bi-layers'
      />

      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Company KYB</span>
        </div>
      </div>
      <AsideMenuItem
        to='/kyb/overview'
        icon='/assets/media/icons/duotune/communication/com013.svg'
        title='Overview'
        fontIcon='bi-layers'
      />
      <AsideMenuItem
        to='/kyb/data'
        icon='/assets/media/icons/duotune/general/gen017.svg'
        title='Data Records'
        fontIcon='bi-layers'
      />

      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>ADMINISTRATION</span>
        </div>
      </div>
      <AsideMenuItem
        to='/administration/settings'
        icon='/assets/media/icons/duotune/communication/com014.svg'
        title='Settings'
        fontIcon='bi-layers'
      />
      <AsideMenuItem
        to='/administration/help'
        icon='/assets/media/icons/duotune/ecommerce/ecm008.svg'
        title='Help'
        fontIcon='bi-layers'
      />

      {/* <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>AMENDMENTS</span>
        </div>
      </div>
      <AsideMenuItem
        to='/amendments/person'
        icon='/assets/media/icons/duotune/communication/com014.svg'
        title='Person'
        fontIcon='bi-layers'
      /> */}
      {/* <AsideMenuItem
        to='/amendments/company'
        icon='/assets/media/icons/duotune/ecommerce/ecm008.svg'
        title='Company'
        fontIcon='bi-layers'
      /> */}
    </>
  )
}
